import { faCircleMinus, faCirclePlus, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import CloseIcon from '../../../assets/Close.svg';
import { FormTexts } from '../../../language/Texts';
import { IKeyValue } from '../../../models/IComponent';
import { ComponentType } from '../../../models/componentType.enum';
import './KeyValues.scss';

interface KeyValuesProps {
    keyValues: {
        key: string;
        value: string;
    }[],
    setKeyValues: (keyValues: IKeyValue[]) => void,
    type?: ComponentType
}
function KeyValues({ keyValues, setKeyValues, type }: KeyValuesProps) {
    const [focusedInput, setFocusedInput] = useState<{ index: number, field: 'key' | 'value' } | null>(null);
    const handleInputChange = (index: number, field: 'key' | 'value', newValue: string) => {
        const updatedKeyValues = [...keyValues];
        updatedKeyValues[index][field] = newValue;
        setKeyValues(updatedKeyValues);
    };

    const handleClear = (index: number, field: 'key' | 'value') => {
        const updatedKeyValues = [...keyValues];
        updatedKeyValues[index][field] = '';
        setKeyValues(updatedKeyValues);
    };

    const handleFocus = (index: number, field: 'key' | 'value') => {
        setFocusedInput({ index, field });
    };

    const handleBlur = () => {
        setFocusedInput(null);
    };

    const handleAddFields = () => {
        setKeyValues([...keyValues, { key: '', value: '' }]);
    };

    const handleRemoveFields = (index) => {
        if (index >= 0 && index < keyValues.length) {
            const updatedKeyValues = [...keyValues];
            updatedKeyValues.splice(index, 1);
            setKeyValues(updatedKeyValues);
        }
    };

    const getPlusButton = () => {
        if (type === ComponentType.GEMUE_EXTERNAL) {
            return <button type="button" className="icon_wrapper_1" onClick={handleAddFields} tabIndex={-1}>
                <span className="icon_wrapper_2"                >
                    <FontAwesomeIcon icon={faPlus} className="add_remove_icon" />
                </span>
            </button>
        }
        return <Button type='button' className='add_icon_wrapper' onClick={handleAddFields} data-testid="add_icon_wrapper" tabIndex={-1}>
            <FontAwesomeIcon className="add_icon" icon={faCirclePlus} />
        </Button>
    }

    return (
        <div
            className={`input_pair ${type === ComponentType.GEMUE_EXTERNAL ? 'gemue_input_pair' : ''}`}
        >
            <label
                className={`input_label ${type === ComponentType.GEMUE_EXTERNAL ? 'gemue_input_label' : ''}`}
            >{FormTexts.keyValues}</label>
            {keyValues?.map((kv, index) => (
                <div key={index} className='kv_input_wrapper'>
                    <div
                        className="input_wrapper"
                    >
                        <div className="input_container">
                            <input
                                className={`input_field kv_input_key ${type === ComponentType.GEMUE_EXTERNAL ? 'gemue_input_field' : ''}`}
                                type="text"
                                placeholder="Key"
                                value={kv.key}
                                onChange={(e) => handleInputChange(index, 'key', e.target.value)}
                                onFocus={() => handleFocus(index, 'key')}
                                onBlur={handleBlur}
                                data-testid="kv_input"
                            />
                            {kv.key && focusedInput?.index === index && focusedInput?.field === 'key' && (
                                <button
                                    type="button"
                                    className={`${type === ComponentType.GEMUE_EXTERNAL ? 'gemue_input_clear_button' : 'input_clear_button '}`}
                                    onClick={() => handleClear(index, 'key')}
                                    onMouseDown={(e) => e.preventDefault()}
                                    aria-label="Clear input"
                                    tabIndex={-1}
                                >
                                    <img src={CloseIcon} alt="Clear" className="clear_icon default_icon" />
                                </button>
                            )}
                        </div>
                        <div className="input_container">
                            <input
                                className={`input_field kv_input_value ${type === ComponentType.GEMUE_EXTERNAL ? 'gemue_input_field' : ''}`}
                                type="text"
                                placeholder="Value"
                                value={kv.value}
                                onChange={(e) => handleInputChange(index, 'value', e.target.value)}
                                onFocus={() => handleFocus(index, 'value')}
                                onBlur={handleBlur}
                                data-testid="kv_input"
                            />
                            {kv.value && focusedInput?.index === index && focusedInput?.field === 'value' && (
                                <button
                                    type="button"
                                    className={`${type === ComponentType.GEMUE_EXTERNAL ? 'gemue_input_clear_button' : 'input_clear_button '}`}
                                    onClick={() => handleClear(index, 'value')}
                                    onMouseDown={(e) => e.preventDefault()}
                                    aria-label="Clear input"
                                    tabIndex={-1}
                                >
                                    <img src={CloseIcon} alt="Clear" className="clear_icon default_icon" />
                                </button>
                            )}
                        </div>
                    </div>

                    <button type="button" className="icon_wrapper_1 remove_icon_wrapper" onClick={() => handleRemoveFields(index)} tabIndex={-1}>
                        <span className="icon_wrapper_2"                >
                            <FontAwesomeIcon icon={faMinus} className="add_remove_icon" />
                        </span>
                    </button>
                </div>
            ))}
            {getPlusButton()}
        </div>
    )
}

export default KeyValues
